export default {
  trainingPlan: {
    title: 'Kế hoạch tập luyện',
    subtitle: 'Chọn kế hoạch tập luyện hoàn hảo và bắt đầu hành trình thành công của bạn',
    metaTitle: 'Kế hoạch tập luyện - Running Wild',
    metaDescription: 'Kế hoạch tập luyện toàn diện cho người chạy bộ ở mọi cấp độ. Từ 5K đến marathon, nhận lịch trình tập luyện cá nhân hóa với các bài tập chi tiết hàng tuần.',
    recommended: 'Khuyến nghị',
    weeks: 'Tuần',
    distance: 'Khoảng cách',
    targetTime: 'Thời gian mục tiêu',
    startPlan: 'Bắt đầu kế hoạch này',
    backToPlans: 'Quay lại danh sách',
    trainingZones: 'Vùng tập luyện',
    weeklySchedule: 'Lịch trình hàng tuần',
    selectWeek: 'Chọn tuần',
    setGoal: 'Đặt mục tiêu',
    setRaceGoal: 'Đặt mục tiêu cuộc đua',
    goalDescription: 'Đặt thời gian hoàn thành mục tiêu cho ngày đua. Điều này sẽ giúp tùy chỉnh kế hoạch tập luyện của bạn.',
    targetHours: 'Giờ mục tiêu',
    hoursPlaceholder: 'Giờ',
    minutesPlaceholder: 'Phút',
    secondsPlaceholder: 'Giây',
    saveGoal: 'Lưu mục tiêu',
    cancel: 'Hủy',
    invalidTime: 'Vui lòng nhập thời gian hợp lệ.',
    goalSaved: 'Mục tiêu đã được lưu thành công!',
    readyToStart: 'Sẵn sàng bắt đầu?',
    actionSubtitle: 'Chọn bước tiếp theo để bắt đầu hành trình tập luyện của bạn',
    startTrainingDesc: 'Bắt đầu chương trình tập luyện',
    setGoalDesc: 'Xác định thời gian hoàn thành mục tiêu',
    downloadPlanDesc: 'Lưu kế hoạch vào thiết bị',
    sharePlan: 'Chia sẻ kế hoạch',
    sharePlanDesc: 'Chia sẻ với bạn bè',
    goalSet: 'Đã đặt mục tiêu',
    clearGoal: 'Xóa mục tiêu',
    goalCleared: 'Mục tiêu đã được xóa thành công!',
    week: 'Tuần',
    startTraining: 'Bắt đầu tập luyện',
    downloadPlan: 'Tải xuống kế hoạch',
    downloadSuccess: 'Kế hoạch tập luyện "{planName}" đã được tải xuống thành công!',
    downloadError: 'Vui lòng chọn một kế hoạch tập luyện trước.',
    planOverview: 'Tổng quan kế hoạch',
    goalTime: 'Thời gian mục tiêu',
    goalStatus: 'Trạng thái mục tiêu',
    active: 'Đang hoạt động',
    // Additional keys for TrainingPlan.vue
    targetPace: 'Pace mục tiêu',
    goalAdjusted: 'Điều chỉnh theo mục tiêu',
    noTraining: 'Không tập luyện',
    recoveryAndRestDay: 'Nghỉ ngơi và phục hồi',
    days: {
      monday: 'Thứ 2',
      tuesday: 'Thứ 3',
      wednesday: 'Thứ 4',
      thursday: 'Thứ 5',
      friday: 'Thứ 6',
      saturday: 'Thứ 7',
      sunday: 'Chủ nhật'
    },
    startTrainingMessage: 'Bắt đầu kế hoạch tập luyện của bạn!',
    shareError: 'Không có kế hoạch nào được chọn để chia sẻ',
    shareCopied: 'Liên kết đã được sao chép vào clipboard!',
    sharePrompt: 'Sao chép liên kết này:'
  },
  eventDashboard: {
    title: 'Bảng điều khiển sự kiện',
    filter: 'Bộ lọc & Tìm kiếm',
    level: 'Level',
    overall: 'Tổng thể',
    female: 'Nữ',
    male: 'Nam',
    team: 'Đội',
    search: 'Tìm kiếm',
    searchPlaceholder: 'Nhập tên vận động viên...',
    ranking: 'Bảng xếp hạng',
    participants: '{count} tham gia',
    page: 'Trang {current}/{total}',
    points: 'Điểm',
    actions: 'Hành động',
    inspect: 'Soi',
    cert: 'Cert',
    next: 'Sau',
    prev: 'Trước',
    first: 'Đầu',
    last: 'Cuối',
    results: 'kết quả',
    join: 'Tham gia',
    stats: 'Thống kê',
    total: 'Tổng',
    type: 'Loại',
    name: 'Tên hoạt động',
    date: 'Ngày',
    km: 'Km',
    pace: 'Pace',
    report: 'Báo cáo',
    activityDetails: 'Chi tiết hoạt động',
    totalPoints: 'Tổng điểm:',
    totalKm: 'Tổng km:',
    totalDays: 'Tổng ngày:',
    summaryByType: 'Thống kê theo loại ({count} hoạt động):',
    number: '#',
    teamName: 'Tên đội',
    levelName: 'Tên level',
    eventName: 'Tên sự kiện',
    eventDates: '{from} - {to}',
    statusUpcoming: 'Sắp diễn ra',
    statusExpired: 'Đã kết thúc',
    statusActive: 'Đang diễn ra',
    activityList: 'Danh sách hoạt động',
    viewOnStrava: 'Xem trên Strava',
    resetFilters: 'Đặt lại bộ lọc',
    var: 'Var',
    io: 'I/O',
    dateTime: 'Ngày giờ',
    soiiReport: 'Soii/Báo cáo',
    inSportWeTrust: 'Thể thao là niềm tin! Thoải mái nhé (^.^)',
    failedInspection: 'Không thể tải kết quả soi.',
    loadingAthletes: 'Đang tải vận động viên...',
    times: 'lần'
  },
  login: {
    brand: 'Nghiện Chạy Bộ',
    welcome: 'Chào mừng bạn đến với cộng đồng!',
    instruction: 'Hãy nhấn Đăng nhập bằng Strava để bắt đầu hành trình chạy bộ cùng chúng tôi, kết nối và chia sẻ thành tích với mọi người!',
    loginWithStrava: 'Đăng nhập bằng Strava',
    redirecting: 'Đang chuyển hướng...',
    step1: 'Nhấn nút đăng nhập bằng Strava như hình bên trên',
    guideAlt: 'Hướng dẫn đăng nhập',
    step2: 'Chọn Authorize để cho phép nghienchaybo.com đồng bộ dữ liệu Strava của bạn',
    step3: 'Sau đó, dữ liệu từ Strava của bạn sẽ được đồng bộ tự động đến nghienchaybo.com',
    error: 'Lỗi đăng nhập',
    title: 'Đăng nhập'
  },
  profile: {
    id: 'ID:',
    email: 'Email:',
    athlete_name: 'Tên:',
    total_activities: 'Tổng hoạt động:',
    proMember: 'Thành viên Pro - Đăng ký cao cấp đang hoạt động',
    noChallenges: 'Chưa có thử thách nào',
    joinChallenges: 'Tham gia thử thách để bắt đầu hành trình rèn luyện sức khỏe!',
    editProfile: 'Chỉnh sửa hồ sơ',
    save: 'Lưu',
    saving: 'Đang lưu...',
    optional: 'Tùy chọn',
    emailAddress: 'Địa chỉ email',
    emailPlaceholder: 'Nhập địa chỉ email của bạn',
    invalidEmail: 'Vui lòng nhập địa chỉ email hợp lệ.',
    // Profile configuration fields
    age: 'Tuổi',
    agePlaceholder: 'Nhập tuổi của bạn',
    invalidAge: 'Vui lòng nhập tuổi hợp lệ (1-120)',
    weight: 'Cân nặng',
    weightPlaceholder: 'Nhập cân nặng của bạn',
    invalidWeight: 'Vui lòng nhập cân nặng hợp lệ (1-500 kg)',
    height: 'Chiều cao',
    heightPlaceholder: 'ví dụ: 168',
    heightHelp: 'Nhập chiều cao của bạn bằng centimet (ví dụ: 168 cm)',
    invalidHeight: 'Vui lòng nhập chiều cao hợp lệ (50-300 cm)',
    gender: 'Giới tính',
    selectGender: 'Chọn giới tính',
    genderMale: 'Nam',
    genderFemale: 'Nữ',
    genderUnknown: 'Không xác định',
    invalidGender: 'Vui lòng chọn giới tính',
    autoAnalyseAndShare: 'Tự động phân tích & chia sẻ lên Strava',
    autoAnalyseAndShareHelp: 'Tự động tạo phân tích AI và chia sẻ lên Strava khi bạn tạo hoạt động mới',
    trainingTarget: 'Mục Tiêu Tập Luyện',
    trainingTargetHelp: 'Đặt mục tiêu cho cuộc đua của bạn để theo dõi tiến độ',
    targetFinishTime: 'Thời Gian Hoàn Thành Mục Tiêu',
    targetFinishTimeHelp: 'Ví dụ: Để chạy marathon dưới 4 giờ, nhập 4 giờ 0 phút',
    targetRaceDate: 'Ngày Đua Mục Tiêu',
    targetRaceDateHelp: 'Cuộc đua mục tiêu của bạn diễn ra khi nào? (Định dạng: MM-DD-YYYY)',
    targetSportTypes: 'Loại Thể Thao Mục Tiêu',
    targetSportTypesHelp: 'Chọn các môn thể thao bạn muốn tập luyện (Giữ Ctrl/Cmd để chọn nhiều)',
    goalDescription: 'Mô Tả Mục Tiêu',
    goalDescriptionPlaceholder: 'Mô tả mục tiêu tập luyện của bạn, những gì bạn muốn đạt được, các cuộc đua mục tiêu, hoặc bất kỳ mục tiêu cụ thể nào...',
    goalDescriptionHelp: 'Mô tả này sẽ được AI sử dụng để cung cấp phân tích huấn luyện cá nhân hóa hơn',
    sportRunning: 'Chạy Bộ',
    sportCycling: 'Đạp Xe',
    sportSwimming: 'Bơi Lội',
    sportTriathlon: 'Ba Môn Phối Hợp',
    hours: 'Giờ',
    minutes: 'Phút',
    hoursPlaceholder: 'Giờ',
    minutesPlaceholder: 'Phút',
    myActivities: 'Hoạt động của tôi',
    myChallenges: 'Thử thách của tôi',
    upcoming: 'Sắp diễn ra',
    ended: 'Đã kết thúc',
    active: 'Đang diễn ra',
    start: 'Bắt đầu',
    end: 'Kết thúc',
    viewDetails: 'Xem chi tiết',
    dashboard: 'Bảng điều khiển',
    myAchievement: 'Thành tích của tôi',
    loadingMoreChallenges: 'Đang tải thêm thử thách...',
    loadingAchievement: 'Đang tải thành tích...',
    noAchievementData: 'Không có dữ liệu thành tích.',
    activityList: 'Danh sách hoạt động',
    type: 'Loại',
    name: 'Tên hoạt động',
    date: 'Ngày',
    km: 'Km',
    movingTime: 'Thời gian',
    pace: 'Pace',
    showStats: 'Xem thống kê',
    hideStats: 'Ẩn thống kê',
    count: 'Số lượng',
    block: 'Khối',
    blocks: 'Khối',
    points: 'Điểm',
    updateSuccess: 'Cập nhật hồ sơ thành công!',
    updateFailed: 'Cập nhật hồ sơ thất bại',
    success: 'Thành công',
    error: 'Lỗi',
    validationError: 'Lỗi xác thực',
    pleaseFixValidationErrors: 'Vui lòng sửa các lỗi xác thực trước khi gửi',
    athleteNotFound: 'Không tìm thấy vận động viên',
    pleaseLoginAgain: 'Vui lòng đăng nhập lại để cập nhật hồ sơ',
    redirectingToLogin: 'Không tìm thấy xác thực. Đang chuyển đến trang đăng nhập Strava...',
    achievementLoadFailed: 'Không thể tải thành tích',
    changeAvatar: 'Đổi ảnh đại diện',
    uploadAvatar: 'Tải lên ảnh đại diện',
    dragDropOrClick: 'Kéo và thả ảnh vào đây, hoặc nhấp để chọn',
    supportedFormats: 'Định dạng hỗ trợ: JPG, PNG, GIF (Tối đa 5MB)',
    fileSizeError: 'Kích thước tệp phải nhỏ hơn 5MB',
    selectedFile: 'Tệp đã chọn',
    noFileSelected: 'Vui lòng chọn tệp để tải lên',
    avatarUploadSuccess: 'Tải lên ảnh đại diện thành công!',
    avatarUploadFailed: 'Không thể tải lên ảnh đại diện',
    sessionExpired: 'Phiên làm việc của bạn đã hết hạn. Vui lòng đăng nhập lại.',
    authenticationRequired: 'Yêu cầu xác thực',
    aiGen: 'AI Gen',
    aiImageGen: 'Tạo ảnh AI',
    aiVideoGen: 'Tạo video AI',
    aiTracklogStats: 'Thống kê AI',
    dailyAiAnalysisLimitExceeded: 'Bạn đã đạt giới hạn phân tích AI hàng ngày. Vui lòng thử lại vào ngày mai.',
    aiAnalysisError: 'Lỗi phân tích AI',
    aiAnalysisThinking: 'AI đang suy nghĩ...',
    aiAnalysisThinkingDescription: 'Đang so sánh hoạt động hiện tại của bạn với dữ liệu public gần đây.',
    comparisonPeriod: 'Kỳ so sánh',
    activitiesAnalyzed: 'Số hoạt động đã phân tích',
    loadingAiGen: 'Đang tải dữ liệu AI...',
    tracklogList: 'Danh sách Tracklog',
    tracklogName: 'Tên Tracklog',
    contentTitle: 'Nội dung',
    contentText: 'Nội dung',
    viewAnalysis: 'Xem phân tích',
    updatedAt: 'Ngày giờ cập nhật',
    dateTime: 'Ngày giờ',
    actions: 'Hành động',
    noTracklogData: 'Không có dữ liệu tracklog.',
    aiGeneratedImage: 'Hình ảnh AI',
    aiGeneratedVideo: 'Video AI',
    generatingImage: 'Đang tạo hình ảnh AI... vui lòng chờ hoặc bạn có thể đi đến tab AI generation để xem tiến trình',
    generatingVideo: 'Đang tạo video AI... vui lòng chờ hoặc bạn có thể đi đến tab AI generation để xem tiến trình',
    aiGeneratedFor: 'AI tạo cho',
    generatedOn: 'Tạo lúc',
    downloadImage: 'Tải hình ảnh',
    downloadVideo: 'Tải xuống video',
    shareVideo: 'Chia sẻ video',
    openInNewTab: 'Mở trong tab mới',
    shareImage: 'Chia sẻ hình ảnh',
    onlyMe: 'Chỉ tôi',
    makePublic: 'Công khai',
    privacyUpdated: 'Đã cập nhật quyền riêng tư',
    privacyUpdateFailed: 'Không thể cập nhật quyền riêng tư',
    uploadSourceImage: 'Tải lên hình ảnh nguồn',
    dragDropImage: 'Kéo và thả hình ảnh vào đây hoặc nhấp để chọn',
    changeImage: 'Đổi hình ảnh',
    uploadingImage: 'Đang tải lên hình ảnh...',
    invalidFileType: 'Loại tệp không hợp lệ. Vui lòng chọn tệp hình ảnh.',
    fileTooLarge: 'Tệp quá lớn. Kích thước tối đa là 10MB.',
    uploadFailed: 'Không thể tải lên tệp',
    videoNotSupported: 'Trình duyệt của bạn không hỗ trợ thẻ video.',
    // AI History
    myAiHistory: 'Lịch sử AI của tôi',
    loadingAiHistory: 'Đang tải lịch sử AI...',
    errorLoadingAiHistory: 'Không thể tải lịch sử AI',
    noAiHistory: 'Chưa có lịch sử AI',
    generateAiContent: 'Tạo nội dung AI cho hoạt động của bạn để xem ở đây!',
    refreshAiHistory: 'Làm mới lịch sử AI',
    refresh: 'Làm mới',
    startPolling: 'Tự động làm mới',
    stopPolling: 'Dừng tự động làm mới',
    autoRefreshing: 'Đang tự động làm mới...',
    aiHistoryUpdated: 'Lịch sử AI đã được cập nhật',
    updateNotification: 'Cập nhật',
    pollingStopped: 'Tự động làm mới đã dừng do lỗi',
    pollingError: 'Lỗi kết nối',
    activityId: 'ID Hoạt động',
    contentType: 'Loại nội dung',
    status: 'Trạng thái',
    contentUrl: 'URL nội dung',
    createdAt: 'Tạo lúc',
    viewContent: 'Xem nội dung',
    noContent: 'Không có nội dung',
    previous: 'Trước',
    next: 'Tiếp',
    showingResults: 'Hiển thị {start}-{end} trong {total} kết quả',
    unknown: 'Không xác định',
    statusTitle: 'Trạng thái',
    // Preview functionality
    preview: 'Xem trước',
    previewContent: 'Xem trước nội dung',
    open: 'Mở',
    loadingContent: 'Đang tải nội dung...',
    failedToLoadContent: 'Không thể tải nội dung',
    tapToZoom: 'Nhấn để phóng to',
    daily_ai_generation_limit_exceeded: 'Đã vượt quá giới hạn tạo AI hàng ngày. Vui lòng thử lại vào ngày mai. Chạy nhiều hoạt động để nhận thêm lượt (sắp tới ^.^)',
    aiStatus: {
      started: 'Đã bắt đầu',
      finished: 'Đã hoàn thành',
      failed: 'Thất bại',
      processing: 'Đang xử lý',
      error: 'Lỗi'
    },
    // Privacy controls
    privacy: 'Quyền riêng tư',
    public: 'Công khai',
    private: 'Riêng tư',
    makePrivate: 'Riêng tư',
    contentMadePublic: 'Nội dung đã được công khai',
    contentMadePrivate: 'Nội dung đã được riêng tư',
    notAvailable: 'N/A',
    // Additional missing keys
    uploadImageForAiImage: 'Tải lên hình ảnh cho AI',
    dragDropImageForAiImage: 'Kéo và thả hình ảnh vào đây hoặc nhấp để chọn cho AI',
    uploadingAvatar: 'Đang tải lên ảnh đại diện...',
    // Dashboard
    distance: 'Khoảng cách',
    time: 'Thời gian',
    avgSpeed: 'Tốc độ TB',
    avgHR: 'Nhịp tim TB',
    elevation: 'Độ cao',
    loading: 'Đang tải...',
    loadMore: 'Tải thêm',
    noActivities: 'Không có hoạt động nào',
    noActivitiesDescription: 'Bạn chưa tham gia sự kiện nào. Hãy tham gia thử thách để bắt đầu theo dõi hoạt động!',
    errorLoadingActivities: 'Không thể tải hoạt động',
    // No activities modal
    noActivitiesModalTitle: 'Không có hoạt động nào',
    tooFewActivities: 'Quá ít hoạt động',

    noActivitiesModalMessage: 'Bạn chưa đồng bộ hoạt động nào từ Strava. Đồng bộ hoạt động Strava để xem ở đây, hoặc tham gia sự kiện để theo dõi hoạt động mới.',
    tooFewActivitiesMessage: 'Bạn chưa có đủ hoạt động để tạo nội dung AI. Vui lòng đồng bộ hoạt động Strava để xem ở đây, hoặc tham gia sự kiện để theo dõi hoạt động mới.',

    tooFewActivitiesModalSyncSuccess: 'Đồng bộ hoạt động thành công!',
    noActivitiesModalSyncActivities: 'Đồng bộ tất cả hoạt động',

    tooFewActivitiesModalSyncActivities: 'Đồng bộ tất cả hoạt động',
    noActivitiesModalExploreEvents: 'Khám phá sự kiện',

    tooFewActivitiesModalExploreEvents: 'Khám phá sự kiện',
    noActivitiesModalClose: 'Đóng',

    tooFewActivitiesModalClose: 'Đóng',
    noActivitiesModalSyncing: 'Đang đồng bộ hoạt động...',

    tooFewActivitiesModalSyncing: 'Đang đồng bộ hoạt động...',
    noActivitiesModalSyncSuccess: 'Đồng bộ hoạt động thành công!',
    noActivitiesModalSyncStarted: 'Đã bắt đầu đồng bộ hoạt động! Quá trình này có thể mất vài phút.',

    tooFewActivitiesModalSyncStarted: 'Đã bắt đầu đồng bộ hoạt động! Quá trình này có thể mất vài phút.',
    noActivitiesModalSyncError: 'Không thể đồng bộ hoạt động',

    tooFewActivitiesModalSyncError: 'Không thể đồng bộ hoạt động',
    syncInProgressTitle: 'Đang đồng bộ',

    noActivitiesModalSyncFeature: 'Đồng bộ tất cả hoạt động Strava để xem ở đây',
    tooFewActivitiesModalSyncFeature: 'Đồng bộ tất cả hoạt động Strava để xem ở đây',

    noActivitiesModalJoinEventsFeature: 'Tham gia sự kiện với luật tùy chỉnh và thử thách',
    tooFewActivitiesModalJoinEventsFeature: 'Tham gia sự kiện với luật tùy chỉnh và thử thách',

    noActivitiesModalTrackProgressFeature: 'Theo dõi tiến trình và thành tích của bạn',
    tooFewActivitiesModalTrackProgressFeature: 'Theo dõi tiến trình và thành tích của bạn'
  },
  progress: {
    title: 'Theo Dõi Tiến Độ',
    loading: 'Đang tải dữ liệu tiến độ...',
    totalDistance: 'Tổng Quãng Đường',
    totalTime: 'Tổng Thời Gian',
    activities: 'Hoạt Động',
    totalElevation: 'Tổng Độ Cao',
    avgPace: 'Pace Trung Bình',
    avgHR: 'Nhịp Tim TB',
    longestRun: 'Chạy Dài Nhất',
    longestRide: 'Đạp Xe Dài Nhất',
    byType: 'Hoạt Động Theo Loại',
    weeklyTrend: 'Xu Hướng Theo Tuần',
    noData: 'Không có dữ liệu hoạt động cho khoảng thời gian này',
    errorLoadingProgress: 'Lỗi khi tải dữ liệu tiến độ',
    unknown: 'Không xác định',
    last7Days: '7 Ngày Qua',
    last30Days: '30 Ngày Qua',
    last90Days: '90 Ngày Qua',
    eventPeriod: 'Thời Gian Sự Kiện',
    customRange: 'Tùy Chỉnh',
    vsPreviewPeriod: 'so với kỳ trước',
    daysRemaining: 'ngày còn lại',
    progressComplete: 'Hoàn Thành'
  },
  eventDetail: {
    joinCode: 'Mã tham gia',
    level: 'Level',
    team: 'Đội',
    personalTarget: 'Mục tiêu cá nhân',
    paceTarget: 'PACE mục tiêu (5p30)',
    paceFormatHelp: 'Định dạng: 5p30 hoặc 5p00',
    join: 'Tham gia',
    dashboard: 'Bảng xếp hạng',
    teamDashboard: 'Bảng xếp hạng đội',
    upcoming: 'Sắp diễn ra',
    expired: 'Đã kết thúc',
    active: 'Đang diễn ra',
    scoringRules: 'Cách tính điểm',
    error: 'Lỗi',
    varDashboard: 'Bảng tổng hợp',
    title: 'Chi tiết sự kiện',
    selectLevel: 'Vui lòng chọn level của bạn',
    selectTeam: 'Vui lòng chọn đội của bạn',
    enterPaceTarget: 'Hãy nhập pace target của bạn',
    invalidPaceTarget: 'Hãy nhập pace target hợp lệ, ví dụ: 5p30 hoặc 5p00',
    codeMismatch: 'Sai mã / mã không khớp'
  },
  nav: {
    brand: 'NCB',
    home: 'Trang chủ',
    events: 'Sự kiện',
    trainingPlans: 'Kế hoạch tập luyện',
    gpxAnimator: 'Trình tạo hoạt ảnh GPX 3D',
    eventVar: 'Thống kê sự kiện',
    guide: 'Hướng dẫn đăng nhập',
    login: 'Đăng nhập',
    profile: 'Hồ sơ',
    profileLabel: 'Hồ sơ',
    logout: 'Đăng xuất',
    blog: 'Blog',
    about: 'Giới thiệu',
    createEvent: 'Tạo giải chạy'
  },
  events: {
    title: 'Sự kiện',
    noEvents: 'Không có sự kiện nào',
    join: 'Tham gia',
    upcoming: 'Sắp diễn ra',
    expired: 'Đã kết thúc',
    error: 'Lỗi',
    loading: 'Đang tải sự kiện...',
    loadMore: 'Tải thêm sự kiện'
  },
  home: {
    noEvents: 'Không có sự kiện nào',
    noEventsDesc: 'Vui lòng quay lại sau để xem các sự kiện sắp tới!',
    viewDetails: 'Xem chi tiết',
    newActivities: 'Hoạt động mới',
    athlete: 'Vận động viên',
    activity: 'Hoạt động',
    type: 'Loại',
    distance: 'Khoảng cách',
    topEvents: 'Sự kiện nổi bật',
    upcoming: 'Sắp diễn ra',
    ended: 'Đã kết thúc',
    active: 'Đang diễn ra',
    startDate: 'Ngày bắt đầu',
    subscriptionPlans: 'Gói Đăng Ký',
    subscriptionDesc: 'Chọn gói phù hợp với hành trình chạy bộ của bạn',
    recommended: 'ĐỀ XUẤT',
    month: 'tháng',
    save: 'Tiết kiệm',
    unlimitedActivities: 'Theo dõi hoạt động không giới hạn',
    aiAnalysis: 'Phân tích bằng AI',
    prioritySupport: 'Hỗ trợ ưu tiên',
    subscribeNow: 'Đăng Ký Ngay',
    plan: 'Gói',
    duration: 'Thời Hạn',
    totalPrice: 'Tổng Giá',
    pricePerMonth: 'Mỗi Tháng',
    youSave: 'Bạn Tiết Kiệm',
    paymentInstructions: 'Hướng Dẫn Thanh Toán',
    bankTransfer: 'Chuyển Khoản Ngân Hàng',
    bankName: 'Ngân Hàng',
    accountNumber: 'Số Tài Khoản',
    accountName: 'Tên Tài Khoản',
    amount: 'Số Tiền',
    transferNote: 'Nội Dung Chuyển Khoản (Quan Trọng!)',
    transferNoteDesc: 'Vui lòng ghi chính xác nội dung này khi chuyển khoản:',
    copy: 'Sao Chép',
    noteWarning: 'Không có nội dung này, chúng tôi không thể xác minh thanh toán của bạn!',
    scanQrCode: 'Quét Mã QR',
    qrCodeDesc: 'Sử dụng ứng dụng ngân hàng để quét mã QR này:',
    qrNote: 'Mã QR đã bao gồm thông tin tài khoản. Nhớ thêm nội dung chuyển khoản!',
    activationTime: 'Thời Gian Kích Hoạt',
    activationDesc: 'Gói đăng ký của bạn sẽ được kích hoạt trong vòng 24 giờ sau khi chúng tôi xác minh thanh toán. Bạn sẽ thấy huy hiệu PRO trên hồ sơ của mình sau khi được kích hoạt.',
    activationContact: 'Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ với chúng tôi tại',
    enterStravaId: 'Nhập ID Strava Của Bạn',
    stravaIdDesc: 'Vui lòng nhập ID Vận Động Viên Strava của bạn. Bạn có thể tìm thấy nó trong URL hồ sơ Strava của mình.',
    stravaIdPlaceholder: 'ví dụ: 12345678',
    invalidStravaId: 'Vui lòng nhập ID Strava hợp lệ (chỉ số)',
    howToFindStravaId: 'Cách tìm ID Strava của bạn:',
    goToProfile: 'Vào hồ sơ của bạn',
    stravaIdInUrl: 'và xem URL (ví dụ: strava.com/athletes/12345678)',
    subscribingAs: 'Đăng ký với tên',
    stravaIdRequired: 'Vui lòng nhập ID Strava của bạn.',
    invalidStravaIdError: 'Vui lòng nhập ID Strava hợp lệ (chỉ số).',
    missingInfo: 'Thiếu Thông Tin',
    invalidInput: 'Dữ Liệu Không Hợp Lệ',
    paymentNote: 'Bạn sẽ nhận được thông báo khi gói đăng ký được kích hoạt.',
    rateLimitError: 'Quá nhiều yêu cầu. Vui lòng thử lại sau.',
    errorContact: 'Nếu vấn đề vẫn tiếp diễn, vui lòng liên hệ với chúng tôi tại',
    cancel: 'Hủy',
    paymentMade: 'Tôi Đã Thanh Toán',
    copiedToClipboard: 'Đã sao chép!',
    paymentReceived: 'Xác Nhận Thanh Toán',
    paymentConfirmMessage: 'Cảm ơn bạn! Gói đăng ký sẽ được kích hoạt trong vòng 24 giờ sau khi chúng tôi xác minh thanh toán.',
    activePlan: 'Gói Đang Hoạt Động',
    pendingPlan: 'Đang Chờ Xác Nhận Thanh Toán',
    suspendedPlan: 'Gói Đăng Ký Bị Tạm Ngưng',
    status: 'Trạng Thái',
    activeStatus: 'Đang Hoạt Động',
    pendingStatus: 'Đang Chờ',
    validPeriod: 'Thời Hạn',
    daysRemaining: 'Số Ngày Còn Lại',
    days: 'ngày',
    pendingMessage: 'Cảm ơn bạn đã thanh toán! Chúng tôi đang xử lý gói đăng ký của bạn.',
    pendingTimeline: 'Gói đăng ký của bạn sẽ được kích hoạt trong vòng 24 giờ sau khi chúng tôi xác minh thanh toán. Bạn sẽ nhận được thông báo khi đã kích hoạt.',
    needHelp: 'Cần trợ giúp?',
    pendingContact: 'Liên hệ đội ngũ hỗ trợ của chúng tôi tại',
    suspendedMessage: 'Gói đăng ký của bạn đã bị tạm ngưng. Vui lòng chọn gói mới bên dưới để tiếp tục sử dụng các tính năng cao cấp.',
    suspendedContact: 'Nếu bạn có câu hỏi, vui lòng liên hệ với chúng tôi tại',
    paymentError: 'Đã xảy ra lỗi khi gửi xác nhận thanh toán của bạn. Vui lòng liên hệ với bộ phận hỗ trợ.',
    error: 'Lỗi',
    endDate: 'Ngày kết thúc',
    heroTitle: 'Nền tảng sự kiện linh hoạt, tuỳ chỉnh cho mọi môn thể thao',
    heroSubtitle: 'Tạo sự kiện với pace, nhịp tim, khung giờ và mọi môn thể thao từ Strava.',
    getStarted: 'Bắt đầu',
    seeHowItWorks: 'Xem cách hoạt động',
    featuresTitle: 'Tại sao chọn nền tảng của chúng tôi?',
    featureCustomRules: 'Công cụ tuỳ chỉnh luật',
    featureCustomRulesDesc: 'Đặt pace, nhịp tim, khung giờ và nhiều hơn nữa. Linh hoạt cho mọi sự kiện.',
    featureMultiSport: 'Hỗ trợ đa môn thể thao',
    featureMultiSportDesc: 'Không chỉ chạy bộ! Chúng tôi hỗ trợ bơi, đạp xe và mọi môn thể thao từ Strava.',
    featureRuleCustomization: 'Tuỳ chỉnh luật',
    featureRuleCustomizationDesc: 'Tuỳ chỉnh pace, nhịp tim, độ cao, ngày hoạt động và nhiều hơn nữa. Nhận x2, x3 điểm khi chạy vào thời gian đặc biệt!',
    featureTrainingPlans: 'Kế hoạch luyện tập',
    featureTrainingPlansDesc: 'Kế hoạch luyện tập chuyên nghiệp cho Half Marathon và Full Marathon với bài tập có cấu trúc và thiết lập mục tiêu.',
    trackYourGoal: 'Đặt mục tiêu',
    trackYourGoalDesc: 'Xác định mục tiêu của bạn và theo đuổi nó một cách bền bỉ, lặng lẽ.',
    howItWorksTitle: 'Cách hoạt động',
    howStep1: 'Tạo sự kiện',
    howStep2: 'Định nghĩa luật tuỳ chỉnh',
    howStep3: 'Mời người tham gia',
    howStep4: 'Theo dõi & vinh danh',
    topAthletes: 'Vận động viên nổi bật',
    participants: 'Người tham gia',
    eventsCreated: 'Sự kiện đã tạo',
    sportsSupported: 'Môn thể thao hỗ trợ',
    ctaTitle: 'Sẵn sàng tạo sự kiện của riêng bạn?',
    ctaDesc: 'Bắt đầu ngay và trải nghiệm nền tảng sự kiện linh hoạt nhất.',
    trainingPlansTitle: 'Kế hoạch luyện tập chuyên nghiệp',
    trainingPlansSubtitle: 'Chọn từ các kế hoạch luyện tập được thiết kế bởi chuyên gia cho Half Marathon và Full Marathon. Mỗi kế hoạch bao gồm bài tập có cấu trúc, thiết lập mục tiêu và theo dõi tiến độ.',
    halfMarathonPlan: 'Kế hoạch Half Marathon',
    halfMarathonPlanDesc: 'Kế hoạch luyện tập 16 tuần cho cự ly 21.1km',
    fullMarathonPlan: 'Kế hoạch Full Marathon',
    fullMarathonPlanDesc: 'Kế hoạch luyện tập toàn diện 16 tuần cho cự ly 42.2km',
    weeks: 'Tuần',
    targetTime: 'Thời gian mục tiêu',
    startTrainingPlan: 'Bắt đầu kế hoạch luyện tập',
    footerText: 'Đã đăng ký bản quyền.',
    about: 'Giới thiệu',
    contact: 'Liên hệ',
    latestActivity: 'Hoạt động mới nhất',
    // Special Features Section
    specialFeatures: 'Tính năng đặc biệt',
    specialFeaturesDesc: 'Khám phá các công cụ độc đáo được thiết kế cho người thích vận động',
    makeKorlorTitle: 'MakeKorlor',
    makeKorlorDesc: 'Tạo video tuyến đường hoạt ảnh tuyệt đẹp từ file GPX của bạn với đồng bộ âm nhạc',
    trainingPlanTitle: 'Kế hoạch luyện tập',
    trainingPlanDesc: 'Kế hoạch luyện tập cá nhân hóa cho 5K, 10K, half marathon và marathon',
    uploadGpx: 'Tải lên file GPX',
    addMusic: 'Thêm nhạc nền',
    animateRoute: 'Tạo hoạt ảnh tuyến đường',
    exportVideo: 'Xuất video hoạt ảnh',
    weeklySchedules: 'Lịch trình hàng tuần',
    goalSetting: 'Thiết lập mục tiêu',
    progressTracking: 'Theo dõi tiến độ',
    exportPlans: 'Xuất kế hoạch',
    tryMakeKorlor: 'Thử MakeKorlor',
    startTraining: 'Bắt đầu luyện tập',
    // Login CTA Section
    redirectingToFeed: 'Đang chuyển hướng đến feed hoạt động của bạn...',
    joinCommunity: 'Tham gia cộng đồng chạy bộ!',
    loginBenefit: 'Kết nối với những người bạn cùng chạy, theo dõi tiến trình và truy cập các tính năng đặc biệt',
    connectRunners: 'Kết nối với người chạy',
    trackProgress: 'Theo dõi tiến trình',
    exclusiveFeatures: 'Tính năng đặc biệt',
    loginNow: 'Đăng nhập với Strava',
    freeToJoin: 'Miễn phí và chỉ mất vài giây!'
    ,
    // Subscription & AI Coach additions
    aiCoachTitle: 'Mở khóa Huấn luyện viên Chạy Bộ AI',
    aiCoachSubtitle: 'Biến mỗi buổi chạy thành những gợi ý dễ áp dụng. Luyện tập thông minh, tránh chững lại, chinh phục kỷ lục mới.',
    seePlans: 'Xem gói & giá',
    learnMore: 'Tìm hiểu thêm',
    weeklyVolume: 'Khối lượng tuần',
    easyPace: 'Pace dễ',
    sleepRecovery: 'Điểm phục hồi',
    formSignal: 'Tín hiệu form',
    stable: 'Ổn định',
    compareTitle: 'Vì sao nên lên PRO?',
    free: 'Miễn phí',
    pro: 'PRO',
    freeBasicTracking: 'Theo dõi cơ bản',
    freeHistory: 'Lịch sử gần đây',
    freeCommunity: 'Bảng tin cộng đồng',
    proSmartInsights: 'Insight sau mỗi buổi chạy',
    proPersonalPlans: 'Nhắc tập cá nhân hoá',
    proFormSignals: 'Tín hiệu kỹ thuật & nỗ lực',
    proTrendlines: 'Biểu đồ xu hướng & tiến bộ',
    proPrioritySupport: 'Hỗ trợ ưu tiên',
    faqTitle: 'Câu hỏi thường gặp',
    // AI hero points
    aiPointPersonalizedInsightsTitle: 'Gợi ý cá nhân hoá',
    aiPointPersonalizedInsightsDesc: 'Nhận gợi ý đơn giản, dễ áp dụng sau mỗi buổi chạy.',
    aiPointTrainSmarterTitle: 'Tập thông minh',
    aiPointTrainSmarterDesc: 'Nhắc nhở thích ứng giúp tiến bộ mà không quá tải.',
    aiPointSeeProgressTitle: 'Thấy tiến bộ thực sự',
    aiPointSeeProgressDesc: 'Biểu đồ xu hướng làm rõ điều gì đang cải thiện.',
    aiPointStayMotivatedTitle: 'Giữ động lực',
    aiPointStayMotivatedDesc: 'Cột mốc và chuỗi ngày giúp bạn duy trì sự đều đặn.',
    // How it works (subscription AI)
    howConnectTitle: 'Kết nối hoạt động của bạn',
    howConnectDesc: 'Cứ chạy như bình thường. Chúng tôi tự đồng bộ và phân tích.',
    howAnalyzeTitle: 'AI phân tích mẫu',
    howAnalyzeDesc: 'Chúng tôi phát hiện xu hướng về pace, nỗ lực và độ đều đặn.',
    howGuidanceTitle: 'Nhận hướng dẫn rõ ràng',
    howGuidanceDesc: 'Mẹo ngắn gọn áp dụng ngay buổi chạy tiếp theo.',
    // FAQ
    faqQ1: 'Phân tích AI giúp tôi chạy tốt hơn như thế nào?',
    faqA1P1: 'Chúng tôi tóm tắt dữ liệu phức tạp thành những gợi ý đơn giản: nên làm gì nhiều hơn, ít hơn hoặc khác đi.',
    faqA1P2: 'Bạn sẽ thấy được các mẫu qua nhiều tuần, không chỉ từng buổi chạy đơn lẻ.',
    faqQ2: 'Gói PRO có phù hợp cho người mới bắt đầu?',
    faqA2P1: 'Có. Hướng dẫn được viết bằng ngôn ngữ dễ hiểu và tập trung vào các bước đơn giản tiếp theo.',
    faqA2P2: 'Nó giúp cả người chạy mới và có kinh nghiệm tránh bị chững lại.',
    faqQ3: 'Tôi nhận được gì sau khi thanh toán?',
    faqA3P1: 'Gói đăng ký của bạn sẽ được kích hoạt trong vòng 24 giờ sau khi xác minh.',
    faqA3P2: 'Bạn sẽ thấy huy hiệu PRO và mở khóa các phân tích AI tự động.',
    faqQ4: 'Tôi có thể hủy bất cứ lúc nào không?',
    faqA4P1: 'Có. Gói của bạn chạy đến hết kỳ đã thanh toán rồi sẽ dừng.',
    faqA4P2: 'Không có phí ẩn.'
  },
  teamEventDashboard: {
    title: 'Bảng xếp hạng đội',
    noTeams: 'Không có đội nào',
    join: 'Tham gia đội',
    team: 'Đội',
    teams: 'Đội',
    members: 'Thành viên',
    points: 'Điểm',
    rank: 'Hạng',
    upcoming: 'Sắp diễn ra',
    expired: 'Đã kết thúc',
    teamsCount: '{count} {teamLabel}',
    loadingMoreTeams: 'Đang tải thêm đội...',
    noTeamsFound: 'Không có đội nào',
    noTeamsJoined: 'Chưa có đội nào tham gia sự kiện này.',
    loadingTeams: 'Đang tải đội...'
  },
  eventVar: {
    loading: 'Đang tải thống kê đội...',
    error: 'Lỗi tải dữ liệu',
    retry: 'Thử lại',
    export: 'Xuất CSV',
    exportCSV: 'Xuất ra CSV',
    refresh: 'Làm mới',
    searchPlaceholder: 'Tìm kiếm theo tên hoặc đội...',
    allTeams: 'Tất cả đội',
    allGenders: 'Tất cả giới tính',
    male: 'Nam',
    female: 'Nữ',
    allActivityTypes: 'Tất cả loại hoạt động',
    clearFilters: 'Xóa bộ lọc',
    teamStats: 'Thống kê đội',
    rank: 'Hạng',
    athlete: 'Vận động viên',
    gender: 'Giới tính',
    team: 'Đội',
    totalAthletes: '{count} vận động viên',
    showing: 'Hiển thị {count} trong {total} vận động viên',
    previous: 'Trước',
    next: 'Sau',
    largeScreenTitle: 'Tối ưu cho màn hình lớn',
    largeScreenMessage: 'Trang này chứa thống kê chi tiết và bảng dữ liệu được tối ưu hóa để xem trên máy tính để bàn và máy tính bảng. Để có trải nghiệm tốt nhất, chúng tôi khuyến nghị sử dụng màn hình lớn hơn.',
    featureTable: 'Xem bảng đầy đủ với tất cả cột dữ liệu',
    featureFilters: 'Tùy chọn tìm kiếm và lọc nâng cao',
    featureExport: 'Xuất dữ liệu ra định dạng CSV',
    continueAnyway: 'Tiếp tục',
    teamDashboard: 'Bảng xếp hạng đội',
    eventDashboard: 'Bảng điều khiển sự kiện',
    inspectionResults: 'Kết quả soi',
    noSimilarActivities: 'Không tìm thấy hoạt động tương tự.',
    inspection: 'Soi',
    close: 'Đóng',
    inspectionLoading: 'Đang phân tích tracklog.',
    inspectionSubtitle: 'Phần này hiển thị các nhóm hoạt động có lộ trình tương tự hoặc có dấu hiệu bất thường. Mỗi nhóm có thể là trùng lặp hoặc bất thường.',
    showingGroups: 'Hiển thị {from}–{to} trên tổng số {total} nhóm',
    pageSize: 'Số nhóm/trang:',
    jumpToPage: 'Trang:',
    group: 'Nhóm',
    activityName: 'Tên hoạt động',
    teamName: 'Tên đội',
    pace: 'Pace',
    distance: 'Khoảng cách',
    movingTime: 'Thời gian di chuyển',
    elapsedTime: 'Thời gian thực',
    avgHR: 'Nhịp tim TB',
    avgWatts: 'Công suất TB',
    elevHigh: 'Độ cao tối đa',
    elevLow: 'Độ cao tối thiểu',
    avgCadence: 'Cadence TB'
  },
  eventMap: {
    loadingMap: 'Đang tải bản đồ...'
  },
  app: {
    brand: 'nghienchaybo.com',
    tagline: 'Thể thao ảo | Công nghệ sức khỏe - 2025',
    powered: 'Vận hành bởi Strava | Đang thử nghiệm Beta',
    home: 'Trang chủ',
    backToTop: 'Lên đầu trang',
    contactUs: 'Liên Hệ',
    email: 'Email',
    phone: 'Điện Thoại',
    affiliateTitle: 'Liên kết đối tác',
    affiliateYoutube: '👨💻 Học lập trình cùng Ahaxu 👨💻',
    affiliate42x: '42xChallenge.Com',
    copyright: 'Đã đăng ký bản quyền.'
  },
  feed: {
    title: 'Hoạt động gần đây',
    loadMore: 'Tải thêm hoạt động',
    welcomeBack: 'Chào mừng trở lại, {name}!',
    athlete: 'Vận động viên',
    stayConnected: 'Kết nối với cộng đồng chạy bộ của bạn',
    joinEvent: 'Tham gia sự kiện',
    profile: 'Hồ sơ',
    aiYourProfile: 'Tạo AI cho riêng bạn',
    profileLabel: 'Hồ sơ',
    recentActivity: 'Hoạt động gần đây',
    loadingActivities: 'Đang tải hoạt động...',
    aiGenerated: 'AI tạo ra',
    viewFullSize: 'Xem kích thước đầy đủ',
    noRecentActivities: 'Không có hoạt động gần đây',
    followAthletes: 'Theo dõi một số vận động viên hoặc tham gia sự kiện để xem hoạt động ở đây',
    exploreEvents: 'Khám phá sự kiện',
    quickTools: 'Công cụ nhanh',
    makeKorlor: 'MakeKorlor',
    trainingPlans: 'Kế hoạch luyện tập',
    activityImage: 'Hình ảnh hoạt động',
    activity: 'Hoạt động',
    aiGeneratedImage: 'Hình ảnh AI tạo ra',
    aiGeneratedVideo: 'Video AI tạo ra',
    videoNotSupported: 'Trình duyệt của bạn không hỗ trợ video HTML5.'
  },
  makeKorlor: {
    title: 'Trình tạo hoạt ảnh GPX 3D',
    subtitle: 'Trực quan hóa đường đi GPX với hoạt ảnh 3D và đồng bộ âm nhạc',
    uploadGpx: 'Tải lên tệp GPX',
    uploadGpxPlaceholder: 'Chọn tệp GPX để tạo hoạt ảnh...',
    addMusic: 'Thêm nhạc (Tùy chọn)',
    addMusicPlaceholder: 'Chọn tệp âm thanh...',
    animationSpeed: 'Tốc độ hoạt ảnh:',
    markerSize: 'Kích thước điểm đánh dấu:',
    play: 'Phát',
    pause: 'Tạm dừng',
    reset: 'Đặt lại',
    toggleSatellite: 'Chuyển đổi vệ tinh',
    toggleTerrain: 'Chuyển đổi địa hình',
    toggleStreet: 'Chuyển đổi đường phố',
    currentSpeed: 'Tốc độ hiện tại:',
    elevation: 'Độ cao:',
    distance: 'Khoảng cách:',
    trackInfo: 'Thông tin đường đi',
    totalDistance: 'Tổng khoảng cách:',
    totalTime: 'Tổng thời gian:',
    avgSpeed: 'Tốc độ trung bình:',
    maxSpeed: 'Tốc độ tối đa:',
    loading: 'Đang xử lý tệp GPX...',
    gpxLoaded: 'Tệp GPX đã được tải thành công!',
    musicLoaded: 'Tệp nhạc đã được tải! Nhạc sẽ đồng bộ với tốc độ hoạt ảnh.',
    defaultMusicLoaded: 'Nhạc mặc định đã được tải! Nhạc sẽ đồng bộ với tốc độ hoạt ảnh.',
    errorLoadingGpx: 'Lỗi tải tệp GPX:',
    errorLoadingMusic: 'Lỗi tải tệp nhạc:',
    noGpxFile: 'Vui lòng tải tệp GPX trước!',
    noTrackData: 'Không có dữ liệu đường đi để xuất!',
    processing: 'Đang xử lý tệp GPX...',
    exportSuccess: 'Dữ liệu đường đi đã được xuất thành công!',
    speedUp: '🚀 Nhanh hơn trung bình!',
    speedDown: '😌 Chậm hơn trung bình',
    startPoint: 'Điểm bắt đầu',
    endPoint: 'Điểm kết thúc',
    recordVideo: 'Ghi video',
    stopRecording: 'Dừng ghi',
    recording: 'Đang ghi',
    recordedVideo: 'Video đã ghi',
    videoNotSupported: 'Trình duyệt của bạn không hỗ trợ phát video.',
    downloadVideo: 'Tải xuống video',
    shareVideo: 'Chia sẻ video',
    recordingStarted: 'Bắt đầu ghi! Chọn những gì bạn muốn ghi khi trình duyệt nhắc bạn.',
    recordingStopped: 'Đã dừng ghi.',
    recordingCompleted: 'Ghi video hoàn tất!',
    recordingNotSupported: 'Ghi màn hình không được hỗ trợ trong trình duyệt của bạn.',
    screenAccessDenied: 'Quyền truy cập màn hình bị từ chối. Vui lòng cho phép chia sẻ màn hình.',
    mapNotFound: 'Không tìm thấy bản đồ. Vui lòng thử lại.',
    noVideoRecorded: 'Chưa có video nào được ghi.',
    videoDownloaded: 'Video đã được tải xuống thành công!',
    videoShared: 'Liên kết video đã được sao chép vào clipboard!',
    forceStopRecording: 'Buộc dừng ghi',
    forceStop: 'Buộc dừng',
    recordingForceStopped: 'Đã buộc dừng ghi',
    noRecordingData: 'Không có dữ liệu ghi',
    recordingError: 'Lỗi ghi: {error}',
    animationCompleted: 'Hoạt ảnh hoàn tất, đang dừng ghi',
    autoStoppingRecording: 'Tự động dừng ghi sau hoạt ảnh',
    autoSelecting: 'Tự động chọn',
    shouldAutoRecord: 'Nên tự động ghi tab này',
    ifPrompted: 'Nếu được nhắc',
    selectThisTab: 'Chọn "Tab này" hoặc "Current tab"',
    uploadSourceImage: 'Tải lên ảnh nguồn',
    dragDropImage: 'Kéo thả ảnh vào đây hoặc nhấp để chọn',
    invalidFileType: 'Loại tệp không hợp lệ. Vui lòng chọn tệp hình ảnh.',
    fileTooLarge: 'Tệp quá lớn. Kích thước tối đa là 10MB.',
    uploadFailed: 'Không thể tải lên hình ảnh. Vui lòng thử lại.'
  }
}
